"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reference = exports.ReferenceType = void 0;
var entity_1 = require("./entity");
var ReferenceType;
(function (ReferenceType) {
    ReferenceType["BOOK"] = "book";
    ReferenceType["JOURNAL"] = "journal";
    ReferenceType["WEBSITE"] = "website";
})(ReferenceType = exports.ReferenceType || (exports.ReferenceType = {}));
var Reference = /** @class */ (function (_super) {
    __extends(Reference, _super);
    function Reference(data) {
        var _this = _super.call(this, data) || this;
        if (!_this.referenceData) {
            _this.referenceData = {
                type: ReferenceType.BOOK
            };
        }
        return _this;
    }
    Object.defineProperty(Reference.prototype, "title", {
        get: function () {
            return this.name;
        },
        set: function (value) {
            this.name = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "subTitle", {
        get: function () {
            return this.referenceData.subTitle;
        },
        set: function (value) {
            this.referenceData.subTitle = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "date", {
        get: function () {
            return this.dateFrom;
        },
        set: function (value) {
            this.dateFrom = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "authors", {
        get: function () {
            return this.referenceData.authors;
        },
        set: function (value) {
            this.referenceData.authors = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Reference.prototype, "referenceType", {
        get: function () {
            return this.referenceData.type;
        },
        enumerable: false,
        configurable: true
    });
    Reference.prototype.getHTMLFormat = function (append, short) {
        var _this = this;
        if (short === void 0) { short = false; }
        var shortFields = ['authors', 'title', 'subTitle', 'date'];
        var parts = [];
        this.getFieldsConfig().forEach(function (field) {
            if (short && !shortFields.includes(field.field || field.path || field.toString())) {
                return;
            }
            var value = null;
            if (field.field) {
                value = _this[field.field];
            }
            else if (field.path) {
                value = _this.referenceData[field.path];
            }
            else {
                value = _this.referenceData[field.toString()];
            }
            if (!value || value === '') {
                return;
            }
            if (field.formatter && field.formatter === 'authors') {
                var formattedValue_1 = [];
                value.split(',').forEach(function (oneAuthor) {
                    var nameParts = oneAuthor.trim().split(' ');
                    var formattedAuthor = "<span class=\"small-caps\">" + nameParts.shift() + "</span> " + nameParts.join(' ');
                    formattedValue_1.push(formattedAuthor);
                });
                value = formattedValue_1.join(', ');
            }
            if (field.style) {
                value = "<span class=\"" + field.style + "\">" + value + "</span>";
            }
            parts.push(value);
        });
        if (append) {
            parts.push(append);
        }
        return parts.join(', ');
    };
    Reference.prototype.getShortFormat = function () {
        var _this = this;
        var parts = [];
        ['authors', 'title', 'subTitle', 'date'].forEach(function (field) {
            var value = _this[field];
            if (!value || value === '') {
                return;
            }
            parts.push(value);
        });
        return parts.join(', ');
    };
    Reference.prototype.getFieldsConfig = function () {
        var common = [
            { path: 'authors', style: 'small-caps' },
            { field: 'title', style: 'italic' },
            { path: 'subTitle', style: 'italic' },
        ];
        switch (this.referenceType) {
            case ReferenceType.JOURNAL:
                return __spreadArray(__spreadArray([], common), [
                    'location',
                    'newspaper',
                    { field: 'date' },
                    'year',
                    'issue',
                ]);
            case ReferenceType.WEBSITE:
                return [
                    common[0],
                    common[1],
                    'subTitle',
                    { field: 'date' },
                    'link',
                    'visitDate',
                ];
            default:
                return __spreadArray(__spreadArray([], common), [
                    'series',
                    'translation',
                    'inclusiveBook',
                    'editor',
                    'location',
                    'publisher',
                    { field: 'date' },
                    'isbn',
                    'doi',
                ]);
        }
    };
    return Reference;
}(entity_1.Entity));
exports.Reference = Reference;
